import { Routes, Route, BrowserRouter } from "react-router-dom";
import UploadPage from 'components/UploadPage';
// import BarePage from 'components/BarePage';

function App() {    
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<UploadPage />} />
        {/* <Route path="/bare" element={<BarePage />} /> */}
      </Routes>
    </BrowserRouter>
  );
}

export default App;
